import Enum from '@/modules/core/app/helpers/Enum';

export class InventoryType extends Enum {
  key!: string;
  value!: string;
  color!: string;
  icon!: string;
}
